<template>
  <div class="px-6 pb-6 pt-2">
    <BugSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <b-tabs card nav-class="relative">
      <b-tab title="Version 1" active class="px-2 " title-item-class=" px-2"
        ><b-card-text>Table contents 1</b-card-text>
      </b-tab>
      <b-tab title="Version 2" active class="px-2" title-item-class=" px-2"
        ><b-card-text>Table contents 2</b-card-text>
      </b-tab>

      <b-tab title="Version 3" active class="px-2 " title-item-class=" px-2">
        <div class="mt-4">
          <div class="absolute cust-topQA right-16 ">
            <base-button
              icon
              type="primary"
              class="flex py-1 px-2"
              @click="addBanner"
              ><feather-icon
                icon="SettingsIcon"
                class="mr-2"
                svgClasses="w-4 h-4"
              ></feather-icon
              ><span>Submit bug</span></base-button
            >
          </div>
          <swiper :options="swiperOption" :key="rtl" class=" px-10 ">
            <swiper-slide
              class=" rounded cursor-pointer rounded-lg shadow-none "
            >
              <Box1 />
            </swiper-slide>

            <swiper-slide
              class=" rounded cursor-pointer rounded-lg shadow-none "
            >
              <Box2 />
            </swiper-slide>

            <swiper-slide
              class=" rounded cursor-pointer rounded-lg shadow-none"
            >
              <Box3 />
            </swiper-slide>
            <swiper-slide
              class=" rounded cursor-pointer rounded-lg shadow-none "
            >
              <Box4 />
            </swiper-slide>
            <swiper-slide
              class=" rounded cursor-pointer rounded-lg shadow-none "
            >
              <Box5 />
            </swiper-slide>
            <swiper-slide
              class=" rounded cursor-pointer rounded-lg shadow-none "
            >
              <Box6 />
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@/views/admin/scss/Index.scss";
import Box1 from "./components/Box1.vue";
import Box2 from "./components/Box2.vue";
import Box3 from "./components/Box3.vue";
import Box4 from "./components/Box4.vue";
import Box5 from "./components/Box5.vue";
import Box6 from "./components/Box6.vue";
import BugSidebar from "./components/BugSidebar.vue";
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 15
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true,
        observeParents: true
      },
      openAddBannerSidebar: false
    };
  },
  components: {
    swiper,
    swiperSlide,
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    BugSidebar
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
<style lang="scss">
#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .image-div {
    display: flex;
    flex-flow: row;
  }

  .image > img {
    margin: auto 6px;
    height: 60px;
    width: 60px;
  }

  .item-features {
    background-color: #f7f7f7;
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1),
          0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-bottom: 3px solid #830c81;
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 16px;
  background-color: white !important;
  font-weight: 500;
  color: #830c81;
}
</style>
